const md5 = require('js-md5');

export const isProduct = /https:\/\/hu.sanygroup.com/.test(window.location.href);

const URL = isProduct ? 'Sany2022JHB43852' : 'sanyjhb2022';
export const getRequestHeaders = (params, offset) => {
  if (!params) {
    params = {};
  }
  const timeStamp = Date.now().toString().substring(0, 10);
  params.ts = String(offset ? +timeStamp + +offset : timeStamp);
  const keys = [];
  for (const key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      keys.push(key);
    }
  }
  let temp = '';
  keys
    .sort()
    .filter((key) => {
      const value = params[key];
      return !(
        (
          value == null || // null 或者 undefined
          // eslint-disable-next-line no-prototype-builtins
          (value.hasOwnProperty('length') && value.length === 0) || // 有length属性且是0
          (value.constructor === Object && Object.keys(value).length === 0)
        ) // 是对象且有key值
      );
    })
    .map((key) => {
      let prepareValue = '';
      if (
        Object.prototype.toString.call(params[key]) === '[object Object]' ||
        Object.prototype.toString.call(params[key]) === '[object Array]'
      ) {
        prepareValue = JSON.stringify(params[key]);
      } else {
        prepareValue = params[key];
      }
      temp += key + '=' + prepareValue + '&';
    });
  temp += 'app_key=' + URL;
  const md = md5(temp);
  return {
    sign: md.toString().toLowerCase(),
    ts: params.ts,
  };
};
